import DoughnutChart from './DoughnutChart';

export default DoughnutChart;

export interface DoughnutChartProps {
  onClick?: (data: any) => void;
  onLoad: () => void;
  chartColors?: string[];
  chartLabels: string[];
  data: any;
  chartKeys: string[];
  loading: boolean;
  isError?: boolean;
  emptyMessage?: string;
  legendColor?: string;
  showPercentage?: boolean;
  chartLabelPosition?: 'top' | 'bottom';
  chartHeight?: number;
  chartWidth?: number;
  isLegendDisplay?: boolean;
}
